import { WithdrawalRequest } from '.'
import { ButtonBox, PageSubtitle, PageTitle } from './styles'
import { DASHCOLORS, DashboardhMediumButton } from 'bd-web-components'
import { useIsWebView } from '../../hooks/is-webview'
import { baixarPdf } from '../../Pages/OldAdvanceAnalytics/page-helper'

type Props = {
  modalData: WithdrawalRequest
}

export const WithdrawCore = ({ modalData }: Props) => {
  const isWebView = useIsWebView()

  const getDownloadUrl = (url: string | null) => {
    if (!url) return undefined
    return url
  }

  const downloadUrl = getDownloadUrl(modalData.receiptUrl)

  return (
    <>
      {modalData.type === 'withdraw' && (
        <>
          <PageTitle>{modalData.withdrawRawData.accountOwner}</PageTitle>
          <PageSubtitle>{modalData.withdrawRawData.bank}</PageSubtitle>
          <PageTitle>{modalData.value}</PageTitle>
          <ButtonBox>
            {isWebView ? (
              <DashboardhMediumButton
                color="#fff"
                background={DASHCOLORS.SECONDARY_BLUE_01}
                disabled={!modalData.receiptUrl}
                height="48px"
                maxWidth="100%"
                variant="contained"
                width="250px"
                onClick={async () => {
                  if (modalData.receiptUrl) {
                    await baixarPdf(modalData.receiptUrl, 'comprovante.pdf')
                  }
                }}
              >
                <span className="button__submit_code">Acessar</span>
              </DashboardhMediumButton>
            ) : (
              <a style={{ all: 'unset' }} href={downloadUrl} download>
                <DashboardhMediumButton
                  color="#fff"
                  background={DASHCOLORS.SECONDARY_BLUE_01}
                  disabled={!modalData.receiptUrl}
                  height="48px"
                  maxWidth="100%"
                  variant="contained"
                  width="250px"
                >
                  <span className="button__submit_code">Baixar Comprovante</span>
                </DashboardhMediumButton>
              </a>
            )}
          </ButtonBox>
        </>
      )}
    </>
  )
}
